"use strict";

exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};


//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/babel-runtime/helpers/classCallCheck.js
// module id = 66
// module chunks = 0